import { DocumentType } from 'api';
import { yup } from 'form';

import type { UploadDocumentProps, UploadGenericDocumentProps } from './types';

export const UploadGenericDocumentSchema = yup
  .object<UploadGenericDocumentProps>()
  .shape({
    file: yup.mixed<File>().required('File is required'),
  })
  .required();

export const UploadDocumentSchema = yup.object<UploadDocumentProps>().shape({
  file: yup.mixed<File>().required('File is required'),
  type: yup.string().oneOf(Object.values(DocumentType)).required(),
});
